
let _accessToken = null;

function decodeJWT(token) {
  try {
    const base64 = token.split(".")[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

const tokenService = {
  /* ── Access token (memory only) ──────────────────────────────── */
  getAccessToken: ()        => _accessToken,
  setAccessToken: (token)   => { _accessToken = token; },
  clearAccessToken: ()      => { _accessToken = null; },

  /* ── Refresh token (localStorage) ────────────────────────────── */
  getRefreshToken: ()       => localStorage.getItem("refresh_token"),
  setRefreshToken: (token)  => localStorage.setItem("refresh_token", token),
  clearRefreshToken: ()     => localStorage.removeItem("refresh_token"),

  /* ── Save both after login ────────────────────────────────────── */
  save(access, refresh) {
    _accessToken = access;
    localStorage.setItem("refresh_token", refresh);
  },

  /* ── Clear everything on logout ──────────────────────────────── */
  clearAll() {
    _accessToken = null;
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("adminEmail");
  },


  getUserFromToken(token) {
    const payload = decodeJWT(token || _accessToken);
    if (!payload) return null;
    return {
      id:    payload.user_id,
      email: payload.email || localStorage.getItem("adminEmail") || "",
      exp:   payload.exp,
    };
  },

  hasRefreshToken: () => !!localStorage.getItem("refresh_token"),
};

export default tokenService;